const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ?? 'ajana';

export interface CloudinaryOptions {
  width?: number;
  aspectRatio?: string;
}

export function cloudinaryUrl(publicId: string, opts: CloudinaryOptions = {}): string {
  const transforms = ['f_auto', 'q_auto'];
  if (opts.width) transforms.push(`w_${opts.width}`);
  if (opts.aspectRatio) transforms.push(`ar_${opts.aspectRatio}`, 'c_fill');
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transforms.join(',')}/${publicId}`;
}
